import script from "./Expert_Items.vue?vue&type=script&setup=true&lang=ts"
export * from "./Expert_Items.vue?vue&type=script&setup=true&lang=ts"

import "./Expert_Items.vue?vue&type=style&index=0&id=9efb9604&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9efb9604"]])

export default __exports__